import { CartIdResponse, CartService, CartUtils, RetrieveCartResponse, SessionStorageKeys } from '@aglenergy/shared-library';
import Cookies from 'js-cookie';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { store } from 'app/shared/store/store';
import { isLocalDevelopment } from 'app/shared/utilities/helper-functions';
import { openApiService } from 'app/shared/services/open-api/open-api.service';

const composeHttpHeaders = (): void => {
  openApiService.composeHttpHeaders();
};

const removeCookie = (): void => {
  if (!isLocalDevelopment()) {
    Cookies.remove(SessionStorageKeys.cartId, { path: '/' });
  }
};

export const removeItemFromCart = async (cartId: string, itemId: string): Promise<CartIdResponse> => {
  return await CartService.deleteCart(cartId, parseInt(itemId, 10));
};

export const retrieveCart = async (): Promise<RetrieveCartResponse | null> => {
  const cartId = Cookies.get('cartId');
  if (!cartId) {
    return Promise.resolve(null);
  }
  composeHttpHeaders();
  return await CartService.retrieveCart(cartId)
    .then((cartResponse) => {
      if (CartUtils.cartIsExpired(cartResponse)) {
        removeCookie();
        return null;
      }
      return cartResponse;
    })
    .catch(() => {
      removeCookie();
      return Promise.resolve(null);
    });
};

export const abandonCart = (): void => {
  Cookies.remove('cartId');
  store.set(StoreKeys.cart, null);
  sessionStorage.removeItem('cart');
};
